import styled, { css } from "styled-components";
import { BadgeProps } from "./Badge.types";
import { flexCenter } from "../../mixins/style-mixins";
import COLORS from "../../constants/colors";
import { Breakpoint } from "../../constants/breakpoint";
import { getSizeInPx, isValidValue } from "../../methods/common";
const getBadgeStyle = (type: BadgeProps["type"]) => {
    switch (type) {
        case "active": {
            return {
                primary: COLORS.GREEN_600,
                secondary: COLORS.GREEN_200,
            };
        }
        case "progress": {
            return {
                primary: COLORS.ORANGE_500,
                secondary: COLORS.ORANGE_100,
            };
        }
        case "warning": {
            return {
                primary: COLORS.RED,
                secondary: COLORS.RED_100,
            };
        }
        case "info": {
            return {
                primary: COLORS.PURPLE,
                secondary: COLORS.PURPLE_LIGHT,
            };
        }
        case "default":
        default: {
            return {
                primary: COLORS.GREY_600,
                secondary: COLORS.GREY_200,
            };
        }
    }
};

export const BadgeDot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
`;

export const BadgeWrapper = styled.div<Partial<BadgeProps>>`
    ${flexCenter}
    display: inline-flex;
    gap: 10px;
    padding: 4px 16px;

    ${({ type, onClick, fillType, borderRadius, transparent }) => {
        const { primary, secondary } = getBadgeStyle(type);

        return css`
            cursor: ${!!onClick ? "pointer" : "text"};
            border-radius: ${isValidValue(borderRadius)
                ? getSizeInPx(borderRadius)
                : "16px"};
            color: ${primary};
            background-color: ${secondary};

            ${() => {
                switch (fillType) {
                    case "grey-outline":
                        return css`
                            background-color: ${COLORS.WHITE};
                            border: 2px solid ${COLORS.GREY_200};
                        `;

                    case "outline":
                        return css`
                            background-color: ${COLORS.WHITE};
                            border: 2px solid ${primary};
                        `;

                    case "filled-outline":
                        return css`
                            background-color: ${secondary};
                            border: 2px solid ${primary};
                        `;
                }
            }}

            ${BadgeDot} {
                background-color: ${primary};
            }

            background-color: ${transparent ? "transparent" : ""};
        `;
    }}

    @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
        gap: 5px;
        padding: 2px 10px;
    }
`;
